module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal modal-review",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal__content modal-review__content"
  }, [_c('a', {
    staticClass: "modal-review__btn modal-review__leave",
    attrs: {
      "href": "https://smile-design-orthodontics-reviews.repx.me/review",
      "target": "_blank"
    }
  }, [_vm._v("leave a review"), _c('Icon', {
    attrs: {
      "name": "stars-5-whiteshad"
    }
  })], 1), _c('a', {
    staticClass: "modal-review__btn modal-review__read",
    attrs: {
      "href": "https://smile-design-orthodontics-reviews.repx.me/reviews",
      "target": "_blank"
    }
  }, [_vm._v("read reviews"), _c('Icon', {
    attrs: {
      "name": "stars-5-blackshad"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23f72c02"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/modal/review/modal-review.pug
// module id = 503
// module chunks = 1